import React from "react";

export const StatusContext = React.createContext({
  //
});